jQuery(function initHomeBannerSwiper($) {

	if ( $(".swiper-container.swiper-home-banner .swiper-slide").length > 1 ) {
		options = {
			direction: 'horizontal',
			loop: true,

			autoplay: {
				delay: 7000,
				disableOnInteraction: true,
			},

			keyboardControl: true,
			mousewheelControl: true,

			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			}
		};
		var mySwiper = new Swiper('.swiper-container.swiper-home-banner', options);
	}

});